import { put, all, call, takeEvery } from "redux-saga/effects";
import { fetchAddressList, webSocketTicket } from "../api/common";
import {
  countryListGetSuccess,
  stateListGetSuccess,
  cityListGetSuccess,
  setWebSocketTicket,
  setNotificationWebSocketTicket,
  setDashboardWebSocketTicket,
  setIsDarkTheme,
} from "../actions";
import { common } from "../../constants/actionTypes";
import { address } from "../../constants/componentConstants";
import { statusCode } from "../../constants/apis/apiStatus";

export function* fetchAddressListMainSaga({ data, searchType }) {
  try {
    const listData = yield call(fetchAddressList, data);
    if (listData.length > 0) {
      if (searchType === address.country) {
        yield put(countryListGetSuccess(listData));
      } else if (searchType === address.state) {
        yield put(stateListGetSuccess(listData));
      } else if (searchType === address.city) {
        yield put(cityListGetSuccess(listData));
      }
    }
  } catch (err) {
    console.log(err);
  }
}

export function* fetchWebsocketTicket({ data }) {
  try {
    const ticketData = yield call(webSocketTicket, data);
    if (ticketData?.status === statusCode.Created201) {
      yield put(setWebSocketTicket(ticketData?.data));
    }
  } catch (err) {
    console.log(err);
  }
}

export function* fetchNotificationWebsocketTicket({ data }) {
  try {
    const ticketData = yield call(webSocketTicket, data);
    if (ticketData?.status === statusCode.Created201) {
      yield put(setNotificationWebSocketTicket(ticketData?.data));
    }
  } catch (err) {
    console.log(err);
  }
}
export function* fetchDashboardWebsocketTicket({ data }) {
  try {
    const ticketData = yield call(webSocketTicket, data);
    if (ticketData?.status === statusCode.Created201) {
      yield put(setDashboardWebSocketTicket(ticketData?.data));
    }
  } catch (err) {
    console.log(err);
  }
}

export function* AddressWatcherSaga() {
  yield takeEvery(common.ADDRESS_GET_REQUEST, fetchAddressListMainSaga);
  yield takeEvery(common.GET_WEBSOCKET_TICKET, fetchWebsocketTicket);
  yield takeEvery(common.GET_NOTIFICATION_WEBSOCKET_TICKET, fetchNotificationWebsocketTicket);
  yield takeEvery(common.GET_DASHBOARD_WEBSOCKET_TICKET, fetchDashboardWebsocketTicket);
}

export default function* addressSaga() {
  yield all([AddressWatcherSaga()]);
}
